// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperLinkElement-cls1_m1-","cls2":"PaperLinkElement-cls2_WhM PaperLinkElement-cls1_m1-"};